/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable curly */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable max-len */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { IonTabs, ModalController, NavController } from '@ionic/angular';

import { GlobalVariable } from '../global';
import { PickupTimePage } from '../models/pickup-time/pickup-time.page';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';
import { UserQrPage } from '../user-qr/user-qr.page';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss']
})
export class TabsPage implements OnInit , OnDestroy{
  @ViewChild('tabs', { static: false }) tabs: IonTabs;
  isLoggedIn = false;
  selectedTab: string = 'home';
  links: any;
  bannerImages: string[] = [];
  currentImageIndex: number = 0;
  imageChangeInterval: any;
  constructor(
    public globals: GlobalVariable,
    private modalController: ModalController,
    private localStorageService: LocalStorageService,
    private aib: InAppBrowser,
    private router: Router,
    private nav: NavController,
    private server: UserApiService
  ) {
  }

  ngOnInit() {
   
  }


  ionViewWillEnter() {
    let login = JSON.parse(this.localStorageService.getLogin('isLogin'));
    if (login != null) {
      this.isLoggedIn = login;
      console.log('LoggedIn', this.isLoggedIn);
    }
    this.fetchData();
    this.startImageChangeTimer();
  }

  fetchData() {
    this.bannerImages = this.globals.bannerSliderImages;
  }

  startImageChangeTimer() {
    this.imageChangeInterval = setInterval(() => {
      if (this.bannerImages.length > 0) {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.bannerImages.length;
      }
    }, 4000);
  }

  ngOnDestroy(): void {
    if (this.imageChangeInterval) {
      clearInterval(this.imageChangeInterval);
    }
  }

  async openQRMODAL() {
    if (this.globals.isloggedIn == true) {
      console.log(this.globals.isloggedIn);
      const modal = await this.modalController.create({
        component: UserQrPage,
        componentProps: { data: {} },

        backdropDismiss: true,
        cssClass: 'QRModal',
        animated: true,
        swipeToClose: true,
        mode: 'ios',
      });

      await modal.present();
    } else {
      this.globals.loginmodal();
    }
  }

  openHome() {
    this.aib.create(this.globals.businessData.website);
  }

  openReview() {
    this.aib.create(
      'https://www.google.com/search?kgmid=/g/11gg740b7s&hl=en-PK&q=Hooked&kgs=488dac25519c2f79&shndl=30&shem=lose&source=sh/x/kp/osrp/m5/1#lrd=0x89ef54a819515555:0xdc0562632a8de19c,1',
      '_system'
    );
    // window.open(
    //   'https://www.google.com/search?kgmid=/g/11gg740b7s&hl=en-PK&q=Hooked&kgs=488dac25519c2f79&shndl=30&shem=lose&source=sh/x/kp/osrp/m5/1#lrd=0x89ef54a819515555:0xdc0562632a8de19c,1',
    //   '_blank'
    // );
  }
  orderPage() {
    if (this.globals.catering_enabled) {
      //catering case
      console.log('catering enabled');
      if (!this.globals.udid) {
        console.log('not logged in');
        this.globals.loginmodal();
      } else {
        console.log('logged in');
        if (this.globals.itemsInCart.length > 0) {
          this.router.navigate(['/tabs/tabs/menu']);
        } else {
          this.showPickupModel();
        }
      }
    } else {
      if (
        this.globals.branch_enabled == 1 &&
        this.globals.franchise_enabled == false
      ) {
        // this.router.navigate(['select-branch'])
        this.nav.navigateRoot('select-branch');
      } else {
        this.router.navigate(['/tabs/tabs/menu']);
      }
    }
  }
  async showPickupModel() {
    const modal = await this.modalController.create({
      component: PickupTimePage,
      cssClass: 'customize_pickupModel',
      breakpoints: [0, 0.5, 0.9, 1],
      initialBreakpoint: 1,
      componentProps: {},
    });
    modal.onDidDismiss().then((res) => {
      console.log(res);
      if (res.data.pickup) {
        // this.pickupTime = res.data.pickup;
        // this.convertDate(this.pickupTime);
      }
    });
    return await modal.present();
  }
  viewMenu() {
    console.log('here.....');
    if (this.links) {
      this.aib.create(this.links, '_system');
    } else {
      this.globals.presentToast('No Menu file found.', 'middle');
    }
  }

  getMenu() {
    if (
      this.globals.branch_enabled == 1 &&
      this.globals.franchise_enabled == false
    ) {
      this.nav.navigateRoot('select-branch');
    } else {
      let link = 'https://' + this.globals.businessData.website;

      if (this.globals.businessData && this.globals.businessData.website) {
        this.aib.create(link, '_system');
      } else {
        this.orderPage();
      }
    }
  }
  getSocials() {
    this.globals.loader();
    this.server.getSocials(this.globals.businessHost).subscribe(
      (res) => {
        this.globals.dismiss();
        console.log('social', res);
        if (res.status) {
          // this.viewMenu();
          if (res.files.length > 0) this.links = res.files[0].link;
          this.viewMenu();
        } else {
          this.globals.presentToast('No Menu file found.', 'middle');
        }
      },
      (err) => {
        this.globals.dismiss();
      }
    );
  }

  goTo(path) {
    if (this.globals.businessId == '356') {
      this.globals.opneReview();
    } else {
      if (this.globals.isloggedIn == true) {
        this.router.navigate([path]);
      } else {
        this.globals.loginmodal();
      }
    }
  }

 
}
